const styles = theme => ({
  list: {
    padding: 0,
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/listings/Page/Brands/styles.js